import { getFragmentData, graphql } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { formatAmount } from '../../utils/format-amount.util';
import { ConfidentialValue } from '../../components/ConfidentialValue';
import { useReferencesContext } from '../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

export const CostPage_FixedValue_FixedCost_Fragment = graphql(`
  fragment CostPage_FixedValue_FixedCost_Fragment on FixedCost {
    amount {
      value
      currencyId
    }
  }
`);

interface Props {
  readonly cost: FragmentType<typeof CostPage_FixedValue_FixedCost_Fragment>;
}

export const FixedValue = ({ cost: pCost }: Readonly<Props>) => {
  const cost = getFragmentData(CostPage_FixedValue_FixedCost_Fragment, pCost);

  const { currenciesIdMap } = useReferencesContext();

  return cost.amount ? (
    formatAmount(cost.amount, currenciesIdMap)
  ) : (
    <ConfidentialValue />
  );
};
